/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ConsultantlayoutImport } from './routes/_consultant_layout'
import { Route as ClientlayoutImport } from './routes/_client_layout'
import { Route as AuthlayoutImport } from './routes/_auth_layout'

// Create Virtual Routes

const IndexLazyImport = createFileRoute('/')()
const ConsultantlayoutProfileIndexLazyImport = createFileRoute(
  '/_consultant_layout/profile/',
)()
const ConsultantlayoutOrganizationsIndexLazyImport = createFileRoute(
  '/_consultant_layout/organizations/',
)()
const ConsultantlayoutContractsIndexLazyImport = createFileRoute(
  '/_consultant_layout/contracts/',
)()
const ConsultantlayoutConsultantsIndexLazyImport = createFileRoute(
  '/_consultant_layout/consultants/',
)()
const ClientlayoutTableauDeBordIndexLazyImport = createFileRoute(
  '/_client_layout/tableau-de-bord/',
)()
const ClientlayoutMarketMonitoringIndexLazyImport = createFileRoute(
  '/_client_layout/market-monitoring/',
)()
const ClientlayoutClientProfileIndexLazyImport = createFileRoute(
  '/_client_layout/client-profile/',
)()
const AuthlayoutLoginIndexLazyImport = createFileRoute('/_auth_layout/login/')()
const ConsultantlayoutOrganizationsNewLazyImport = createFileRoute(
  '/_consultant_layout/organizations/new',
)()
const ConsultantlayoutOrganizationsIdLazyImport = createFileRoute(
  '/_consultant_layout/organizations/$id',
)()
const ConsultantlayoutLotsNewLazyImport = createFileRoute(
  '/_consultant_layout/lots/new',
)()
const ConsultantlayoutLotsIdLazyImport = createFileRoute(
  '/_consultant_layout/lots/$id',
)()
const ConsultantlayoutContractsNewLazyImport = createFileRoute(
  '/_consultant_layout/contracts/new',
)()
const ConsultantlayoutContractsIdLazyImport = createFileRoute(
  '/_consultant_layout/contracts/$id',
)()
const AuthlayoutAuthVerifyIndexLazyImport = createFileRoute(
  '/_auth_layout/auth/verify/',
)()

// Create/Update Routes

const ConsultantlayoutRoute = ConsultantlayoutImport.update({
  id: '/_consultant_layout',
  getParentRoute: () => rootRoute,
} as any)

const ClientlayoutRoute = ClientlayoutImport.update({
  id: '/_client_layout',
  getParentRoute: () => rootRoute,
} as any)

const AuthlayoutRoute = AuthlayoutImport.update({
  id: '/_auth_layout',
  getParentRoute: () => rootRoute,
} as any)

const IndexLazyRoute = IndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const ConsultantlayoutProfileIndexLazyRoute =
  ConsultantlayoutProfileIndexLazyImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => ConsultantlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_consultant_layout/profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ConsultantlayoutOrganizationsIndexLazyRoute =
  ConsultantlayoutOrganizationsIndexLazyImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => ConsultantlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_consultant_layout/organizations/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ConsultantlayoutContractsIndexLazyRoute =
  ConsultantlayoutContractsIndexLazyImport.update({
    id: '/contracts/',
    path: '/contracts/',
    getParentRoute: () => ConsultantlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_consultant_layout/contracts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ConsultantlayoutConsultantsIndexLazyRoute =
  ConsultantlayoutConsultantsIndexLazyImport.update({
    id: '/consultants/',
    path: '/consultants/',
    getParentRoute: () => ConsultantlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_consultant_layout/consultants/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ClientlayoutTableauDeBordIndexLazyRoute =
  ClientlayoutTableauDeBordIndexLazyImport.update({
    id: '/tableau-de-bord/',
    path: '/tableau-de-bord/',
    getParentRoute: () => ClientlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_client_layout/tableau-de-bord/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ClientlayoutMarketMonitoringIndexLazyRoute =
  ClientlayoutMarketMonitoringIndexLazyImport.update({
    id: '/market-monitoring/',
    path: '/market-monitoring/',
    getParentRoute: () => ClientlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_client_layout/market-monitoring/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ClientlayoutClientProfileIndexLazyRoute =
  ClientlayoutClientProfileIndexLazyImport.update({
    id: '/client-profile/',
    path: '/client-profile/',
    getParentRoute: () => ClientlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_client_layout/client-profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthlayoutLoginIndexLazyRoute = AuthlayoutLoginIndexLazyImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthlayoutRoute,
} as any).lazy(() =>
  import('./routes/_auth_layout/login/index.lazy').then((d) => d.Route),
)

const ConsultantlayoutOrganizationsNewLazyRoute =
  ConsultantlayoutOrganizationsNewLazyImport.update({
    id: '/organizations/new',
    path: '/organizations/new',
    getParentRoute: () => ConsultantlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_consultant_layout/organizations/new.lazy').then(
      (d) => d.Route,
    ),
  )

const ConsultantlayoutOrganizationsIdLazyRoute =
  ConsultantlayoutOrganizationsIdLazyImport.update({
    id: '/organizations/$id',
    path: '/organizations/$id',
    getParentRoute: () => ConsultantlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_consultant_layout/organizations/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const ConsultantlayoutLotsNewLazyRoute =
  ConsultantlayoutLotsNewLazyImport.update({
    id: '/lots/new',
    path: '/lots/new',
    getParentRoute: () => ConsultantlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_consultant_layout/lots/new.lazy').then((d) => d.Route),
  )

const ConsultantlayoutLotsIdLazyRoute = ConsultantlayoutLotsIdLazyImport.update(
  {
    id: '/lots/$id',
    path: '/lots/$id',
    getParentRoute: () => ConsultantlayoutRoute,
  } as any,
).lazy(() =>
  import('./routes/_consultant_layout/lots/$id.lazy').then((d) => d.Route),
)

const ConsultantlayoutContractsNewLazyRoute =
  ConsultantlayoutContractsNewLazyImport.update({
    id: '/contracts/new',
    path: '/contracts/new',
    getParentRoute: () => ConsultantlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_consultant_layout/contracts/new.lazy').then(
      (d) => d.Route,
    ),
  )

const ConsultantlayoutContractsIdLazyRoute =
  ConsultantlayoutContractsIdLazyImport.update({
    id: '/contracts/$id',
    path: '/contracts/$id',
    getParentRoute: () => ConsultantlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_consultant_layout/contracts/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthlayoutAuthVerifyIndexLazyRoute =
  AuthlayoutAuthVerifyIndexLazyImport.update({
    id: '/auth/verify/',
    path: '/auth/verify/',
    getParentRoute: () => AuthlayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth_layout/auth/verify/index.lazy').then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/_auth_layout': {
      id: '/_auth_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthlayoutImport
      parentRoute: typeof rootRoute
    }
    '/_client_layout': {
      id: '/_client_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ClientlayoutImport
      parentRoute: typeof rootRoute
    }
    '/_consultant_layout': {
      id: '/_consultant_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ConsultantlayoutImport
      parentRoute: typeof rootRoute
    }
    '/_consultant_layout/contracts/$id': {
      id: '/_consultant_layout/contracts/$id'
      path: '/contracts/$id'
      fullPath: '/contracts/$id'
      preLoaderRoute: typeof ConsultantlayoutContractsIdLazyImport
      parentRoute: typeof ConsultantlayoutImport
    }
    '/_consultant_layout/contracts/new': {
      id: '/_consultant_layout/contracts/new'
      path: '/contracts/new'
      fullPath: '/contracts/new'
      preLoaderRoute: typeof ConsultantlayoutContractsNewLazyImport
      parentRoute: typeof ConsultantlayoutImport
    }
    '/_consultant_layout/lots/$id': {
      id: '/_consultant_layout/lots/$id'
      path: '/lots/$id'
      fullPath: '/lots/$id'
      preLoaderRoute: typeof ConsultantlayoutLotsIdLazyImport
      parentRoute: typeof ConsultantlayoutImport
    }
    '/_consultant_layout/lots/new': {
      id: '/_consultant_layout/lots/new'
      path: '/lots/new'
      fullPath: '/lots/new'
      preLoaderRoute: typeof ConsultantlayoutLotsNewLazyImport
      parentRoute: typeof ConsultantlayoutImport
    }
    '/_consultant_layout/organizations/$id': {
      id: '/_consultant_layout/organizations/$id'
      path: '/organizations/$id'
      fullPath: '/organizations/$id'
      preLoaderRoute: typeof ConsultantlayoutOrganizationsIdLazyImport
      parentRoute: typeof ConsultantlayoutImport
    }
    '/_consultant_layout/organizations/new': {
      id: '/_consultant_layout/organizations/new'
      path: '/organizations/new'
      fullPath: '/organizations/new'
      preLoaderRoute: typeof ConsultantlayoutOrganizationsNewLazyImport
      parentRoute: typeof ConsultantlayoutImport
    }
    '/_auth_layout/login/': {
      id: '/_auth_layout/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthlayoutLoginIndexLazyImport
      parentRoute: typeof AuthlayoutImport
    }
    '/_client_layout/client-profile/': {
      id: '/_client_layout/client-profile/'
      path: '/client-profile'
      fullPath: '/client-profile'
      preLoaderRoute: typeof ClientlayoutClientProfileIndexLazyImport
      parentRoute: typeof ClientlayoutImport
    }
    '/_client_layout/market-monitoring/': {
      id: '/_client_layout/market-monitoring/'
      path: '/market-monitoring'
      fullPath: '/market-monitoring'
      preLoaderRoute: typeof ClientlayoutMarketMonitoringIndexLazyImport
      parentRoute: typeof ClientlayoutImport
    }
    '/_client_layout/tableau-de-bord/': {
      id: '/_client_layout/tableau-de-bord/'
      path: '/tableau-de-bord'
      fullPath: '/tableau-de-bord'
      preLoaderRoute: typeof ClientlayoutTableauDeBordIndexLazyImport
      parentRoute: typeof ClientlayoutImport
    }
    '/_consultant_layout/consultants/': {
      id: '/_consultant_layout/consultants/'
      path: '/consultants'
      fullPath: '/consultants'
      preLoaderRoute: typeof ConsultantlayoutConsultantsIndexLazyImport
      parentRoute: typeof ConsultantlayoutImport
    }
    '/_consultant_layout/contracts/': {
      id: '/_consultant_layout/contracts/'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof ConsultantlayoutContractsIndexLazyImport
      parentRoute: typeof ConsultantlayoutImport
    }
    '/_consultant_layout/organizations/': {
      id: '/_consultant_layout/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof ConsultantlayoutOrganizationsIndexLazyImport
      parentRoute: typeof ConsultantlayoutImport
    }
    '/_consultant_layout/profile/': {
      id: '/_consultant_layout/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ConsultantlayoutProfileIndexLazyImport
      parentRoute: typeof ConsultantlayoutImport
    }
    '/_auth_layout/auth/verify/': {
      id: '/_auth_layout/auth/verify/'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthlayoutAuthVerifyIndexLazyImport
      parentRoute: typeof AuthlayoutImport
    }
  }
}

// Create and export the route tree

interface AuthlayoutRouteChildren {
  AuthlayoutLoginIndexLazyRoute: typeof AuthlayoutLoginIndexLazyRoute
  AuthlayoutAuthVerifyIndexLazyRoute: typeof AuthlayoutAuthVerifyIndexLazyRoute
}

const AuthlayoutRouteChildren: AuthlayoutRouteChildren = {
  AuthlayoutLoginIndexLazyRoute: AuthlayoutLoginIndexLazyRoute,
  AuthlayoutAuthVerifyIndexLazyRoute: AuthlayoutAuthVerifyIndexLazyRoute,
}

const AuthlayoutRouteWithChildren = AuthlayoutRoute._addFileChildren(
  AuthlayoutRouteChildren,
)

interface ClientlayoutRouteChildren {
  ClientlayoutClientProfileIndexLazyRoute: typeof ClientlayoutClientProfileIndexLazyRoute
  ClientlayoutMarketMonitoringIndexLazyRoute: typeof ClientlayoutMarketMonitoringIndexLazyRoute
  ClientlayoutTableauDeBordIndexLazyRoute: typeof ClientlayoutTableauDeBordIndexLazyRoute
}

const ClientlayoutRouteChildren: ClientlayoutRouteChildren = {
  ClientlayoutClientProfileIndexLazyRoute:
    ClientlayoutClientProfileIndexLazyRoute,
  ClientlayoutMarketMonitoringIndexLazyRoute:
    ClientlayoutMarketMonitoringIndexLazyRoute,
  ClientlayoutTableauDeBordIndexLazyRoute:
    ClientlayoutTableauDeBordIndexLazyRoute,
}

const ClientlayoutRouteWithChildren = ClientlayoutRoute._addFileChildren(
  ClientlayoutRouteChildren,
)

interface ConsultantlayoutRouteChildren {
  ConsultantlayoutContractsIdLazyRoute: typeof ConsultantlayoutContractsIdLazyRoute
  ConsultantlayoutContractsNewLazyRoute: typeof ConsultantlayoutContractsNewLazyRoute
  ConsultantlayoutLotsIdLazyRoute: typeof ConsultantlayoutLotsIdLazyRoute
  ConsultantlayoutLotsNewLazyRoute: typeof ConsultantlayoutLotsNewLazyRoute
  ConsultantlayoutOrganizationsIdLazyRoute: typeof ConsultantlayoutOrganizationsIdLazyRoute
  ConsultantlayoutOrganizationsNewLazyRoute: typeof ConsultantlayoutOrganizationsNewLazyRoute
  ConsultantlayoutConsultantsIndexLazyRoute: typeof ConsultantlayoutConsultantsIndexLazyRoute
  ConsultantlayoutContractsIndexLazyRoute: typeof ConsultantlayoutContractsIndexLazyRoute
  ConsultantlayoutOrganizationsIndexLazyRoute: typeof ConsultantlayoutOrganizationsIndexLazyRoute
  ConsultantlayoutProfileIndexLazyRoute: typeof ConsultantlayoutProfileIndexLazyRoute
}

const ConsultantlayoutRouteChildren: ConsultantlayoutRouteChildren = {
  ConsultantlayoutContractsIdLazyRoute: ConsultantlayoutContractsIdLazyRoute,
  ConsultantlayoutContractsNewLazyRoute: ConsultantlayoutContractsNewLazyRoute,
  ConsultantlayoutLotsIdLazyRoute: ConsultantlayoutLotsIdLazyRoute,
  ConsultantlayoutLotsNewLazyRoute: ConsultantlayoutLotsNewLazyRoute,
  ConsultantlayoutOrganizationsIdLazyRoute:
    ConsultantlayoutOrganizationsIdLazyRoute,
  ConsultantlayoutOrganizationsNewLazyRoute:
    ConsultantlayoutOrganizationsNewLazyRoute,
  ConsultantlayoutConsultantsIndexLazyRoute:
    ConsultantlayoutConsultantsIndexLazyRoute,
  ConsultantlayoutContractsIndexLazyRoute:
    ConsultantlayoutContractsIndexLazyRoute,
  ConsultantlayoutOrganizationsIndexLazyRoute:
    ConsultantlayoutOrganizationsIndexLazyRoute,
  ConsultantlayoutProfileIndexLazyRoute: ConsultantlayoutProfileIndexLazyRoute,
}

const ConsultantlayoutRouteWithChildren =
  ConsultantlayoutRoute._addFileChildren(ConsultantlayoutRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '': typeof ConsultantlayoutRouteWithChildren
  '/contracts/$id': typeof ConsultantlayoutContractsIdLazyRoute
  '/contracts/new': typeof ConsultantlayoutContractsNewLazyRoute
  '/lots/$id': typeof ConsultantlayoutLotsIdLazyRoute
  '/lots/new': typeof ConsultantlayoutLotsNewLazyRoute
  '/organizations/$id': typeof ConsultantlayoutOrganizationsIdLazyRoute
  '/organizations/new': typeof ConsultantlayoutOrganizationsNewLazyRoute
  '/login': typeof AuthlayoutLoginIndexLazyRoute
  '/client-profile': typeof ClientlayoutClientProfileIndexLazyRoute
  '/market-monitoring': typeof ClientlayoutMarketMonitoringIndexLazyRoute
  '/tableau-de-bord': typeof ClientlayoutTableauDeBordIndexLazyRoute
  '/consultants': typeof ConsultantlayoutConsultantsIndexLazyRoute
  '/contracts': typeof ConsultantlayoutContractsIndexLazyRoute
  '/organizations': typeof ConsultantlayoutOrganizationsIndexLazyRoute
  '/profile': typeof ConsultantlayoutProfileIndexLazyRoute
  '/auth/verify': typeof AuthlayoutAuthVerifyIndexLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '': typeof ConsultantlayoutRouteWithChildren
  '/contracts/$id': typeof ConsultantlayoutContractsIdLazyRoute
  '/contracts/new': typeof ConsultantlayoutContractsNewLazyRoute
  '/lots/$id': typeof ConsultantlayoutLotsIdLazyRoute
  '/lots/new': typeof ConsultantlayoutLotsNewLazyRoute
  '/organizations/$id': typeof ConsultantlayoutOrganizationsIdLazyRoute
  '/organizations/new': typeof ConsultantlayoutOrganizationsNewLazyRoute
  '/login': typeof AuthlayoutLoginIndexLazyRoute
  '/client-profile': typeof ClientlayoutClientProfileIndexLazyRoute
  '/market-monitoring': typeof ClientlayoutMarketMonitoringIndexLazyRoute
  '/tableau-de-bord': typeof ClientlayoutTableauDeBordIndexLazyRoute
  '/consultants': typeof ConsultantlayoutConsultantsIndexLazyRoute
  '/contracts': typeof ConsultantlayoutContractsIndexLazyRoute
  '/organizations': typeof ConsultantlayoutOrganizationsIndexLazyRoute
  '/profile': typeof ConsultantlayoutProfileIndexLazyRoute
  '/auth/verify': typeof AuthlayoutAuthVerifyIndexLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/_auth_layout': typeof AuthlayoutRouteWithChildren
  '/_client_layout': typeof ClientlayoutRouteWithChildren
  '/_consultant_layout': typeof ConsultantlayoutRouteWithChildren
  '/_consultant_layout/contracts/$id': typeof ConsultantlayoutContractsIdLazyRoute
  '/_consultant_layout/contracts/new': typeof ConsultantlayoutContractsNewLazyRoute
  '/_consultant_layout/lots/$id': typeof ConsultantlayoutLotsIdLazyRoute
  '/_consultant_layout/lots/new': typeof ConsultantlayoutLotsNewLazyRoute
  '/_consultant_layout/organizations/$id': typeof ConsultantlayoutOrganizationsIdLazyRoute
  '/_consultant_layout/organizations/new': typeof ConsultantlayoutOrganizationsNewLazyRoute
  '/_auth_layout/login/': typeof AuthlayoutLoginIndexLazyRoute
  '/_client_layout/client-profile/': typeof ClientlayoutClientProfileIndexLazyRoute
  '/_client_layout/market-monitoring/': typeof ClientlayoutMarketMonitoringIndexLazyRoute
  '/_client_layout/tableau-de-bord/': typeof ClientlayoutTableauDeBordIndexLazyRoute
  '/_consultant_layout/consultants/': typeof ConsultantlayoutConsultantsIndexLazyRoute
  '/_consultant_layout/contracts/': typeof ConsultantlayoutContractsIndexLazyRoute
  '/_consultant_layout/organizations/': typeof ConsultantlayoutOrganizationsIndexLazyRoute
  '/_consultant_layout/profile/': typeof ConsultantlayoutProfileIndexLazyRoute
  '/_auth_layout/auth/verify/': typeof AuthlayoutAuthVerifyIndexLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/contracts/$id'
    | '/contracts/new'
    | '/lots/$id'
    | '/lots/new'
    | '/organizations/$id'
    | '/organizations/new'
    | '/login'
    | '/client-profile'
    | '/market-monitoring'
    | '/tableau-de-bord'
    | '/consultants'
    | '/contracts'
    | '/organizations'
    | '/profile'
    | '/auth/verify'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/contracts/$id'
    | '/contracts/new'
    | '/lots/$id'
    | '/lots/new'
    | '/organizations/$id'
    | '/organizations/new'
    | '/login'
    | '/client-profile'
    | '/market-monitoring'
    | '/tableau-de-bord'
    | '/consultants'
    | '/contracts'
    | '/organizations'
    | '/profile'
    | '/auth/verify'
  id:
    | '__root__'
    | '/'
    | '/_auth_layout'
    | '/_client_layout'
    | '/_consultant_layout'
    | '/_consultant_layout/contracts/$id'
    | '/_consultant_layout/contracts/new'
    | '/_consultant_layout/lots/$id'
    | '/_consultant_layout/lots/new'
    | '/_consultant_layout/organizations/$id'
    | '/_consultant_layout/organizations/new'
    | '/_auth_layout/login/'
    | '/_client_layout/client-profile/'
    | '/_client_layout/market-monitoring/'
    | '/_client_layout/tableau-de-bord/'
    | '/_consultant_layout/consultants/'
    | '/_consultant_layout/contracts/'
    | '/_consultant_layout/organizations/'
    | '/_consultant_layout/profile/'
    | '/_auth_layout/auth/verify/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AuthlayoutRoute: typeof AuthlayoutRouteWithChildren
  ClientlayoutRoute: typeof ClientlayoutRouteWithChildren
  ConsultantlayoutRoute: typeof ConsultantlayoutRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AuthlayoutRoute: AuthlayoutRouteWithChildren,
  ClientlayoutRoute: ClientlayoutRouteWithChildren,
  ConsultantlayoutRoute: ConsultantlayoutRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth_layout",
        "/_client_layout",
        "/_consultant_layout"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/_auth_layout": {
      "filePath": "_auth_layout.tsx",
      "children": [
        "/_auth_layout/login/",
        "/_auth_layout/auth/verify/"
      ]
    },
    "/_client_layout": {
      "filePath": "_client_layout.tsx",
      "children": [
        "/_client_layout/client-profile/",
        "/_client_layout/market-monitoring/",
        "/_client_layout/tableau-de-bord/"
      ]
    },
    "/_consultant_layout": {
      "filePath": "_consultant_layout.tsx",
      "children": [
        "/_consultant_layout/contracts/$id",
        "/_consultant_layout/contracts/new",
        "/_consultant_layout/lots/$id",
        "/_consultant_layout/lots/new",
        "/_consultant_layout/organizations/$id",
        "/_consultant_layout/organizations/new",
        "/_consultant_layout/consultants/",
        "/_consultant_layout/contracts/",
        "/_consultant_layout/organizations/",
        "/_consultant_layout/profile/"
      ]
    },
    "/_consultant_layout/contracts/$id": {
      "filePath": "_consultant_layout/contracts/$id.lazy.tsx",
      "parent": "/_consultant_layout"
    },
    "/_consultant_layout/contracts/new": {
      "filePath": "_consultant_layout/contracts/new.lazy.tsx",
      "parent": "/_consultant_layout"
    },
    "/_consultant_layout/lots/$id": {
      "filePath": "_consultant_layout/lots/$id.lazy.tsx",
      "parent": "/_consultant_layout"
    },
    "/_consultant_layout/lots/new": {
      "filePath": "_consultant_layout/lots/new.lazy.tsx",
      "parent": "/_consultant_layout"
    },
    "/_consultant_layout/organizations/$id": {
      "filePath": "_consultant_layout/organizations/$id.lazy.tsx",
      "parent": "/_consultant_layout"
    },
    "/_consultant_layout/organizations/new": {
      "filePath": "_consultant_layout/organizations/new.lazy.tsx",
      "parent": "/_consultant_layout"
    },
    "/_auth_layout/login/": {
      "filePath": "_auth_layout/login/index.lazy.tsx",
      "parent": "/_auth_layout"
    },
    "/_client_layout/client-profile/": {
      "filePath": "_client_layout/client-profile/index.lazy.tsx",
      "parent": "/_client_layout"
    },
    "/_client_layout/market-monitoring/": {
      "filePath": "_client_layout/market-monitoring/index.lazy.tsx",
      "parent": "/_client_layout"
    },
    "/_client_layout/tableau-de-bord/": {
      "filePath": "_client_layout/tableau-de-bord/index.lazy.tsx",
      "parent": "/_client_layout"
    },
    "/_consultant_layout/consultants/": {
      "filePath": "_consultant_layout/consultants/index.lazy.tsx",
      "parent": "/_consultant_layout"
    },
    "/_consultant_layout/contracts/": {
      "filePath": "_consultant_layout/contracts/index.lazy.tsx",
      "parent": "/_consultant_layout"
    },
    "/_consultant_layout/organizations/": {
      "filePath": "_consultant_layout/organizations/index.lazy.tsx",
      "parent": "/_consultant_layout"
    },
    "/_consultant_layout/profile/": {
      "filePath": "_consultant_layout/profile/index.lazy.tsx",
      "parent": "/_consultant_layout"
    },
    "/_auth_layout/auth/verify/": {
      "filePath": "_auth_layout/auth/verify/index.lazy.tsx",
      "parent": "/_auth_layout"
    }
  }
}
ROUTE_MANIFEST_END */
